import {
  DatagridConfigurable,
  List,
  SelectInput,
  TextInput,
} from 'react-admin';

import { TherapistHomeworkCommandPanel } from './TherapistHomeworkCommandPanel';
import { genericCSVExporter } from '@/util/genericCSVExporter';
import {
  renderExportColumns,
  renderGridColumns,
  renderOmitList,
} from '@/components/ConfigurableColumns';
import { columns } from './HomeworkColumns';
import { DefaultListActions } from '@/components/DefaultListActions';
import { DefaultPagination } from '@/components/DefaultPagination';

const statuses = {
  created: 'created (deprecated)',
  draft: 'draft',
  committed: 'committed',
  transcribed: 'transcribed',
  processed: 'processed',
  shared: 'shared',
} as const;

const statusChoices = Object.entries(statuses).map(([id, name]) => ({
  id,
  name,
}));

const filters = [
  <TextInput
    key="therapistId"
    defaultValue=""
    source="therapistId"
    label="Therapist Id"
  />,
  <TextInput
    key="therapistFirstName"
    defaultValue=""
    source="therapistFirstName"
    label="Therapist First Name"
  />,
  <TextInput
    key="therapistLastName"
    defaultValue=""
    source="therapistLastName"
    label="Therapist Last Name"
  />,
  <TextInput
    key="therapistEmail"
    defaultValue=""
    source="therapistEmail"
    label="Therapist Email"
    placeholder="therapist@provider.com"
  />,
  <TextInput
    key="id"
    defaultValue=""
    source="_id"
    label="Session Note Id"
    placeholder="The DASHLESS id"
    parse={value => (value ? { $oid: value } : null)}
    format={value => value?.$oid || ''}
  />,
  <TextInput
    key="clientRecordingId"
    defaultValue=""
    source="clientRecordingId"
    label="Global Id"
    placeholder="The-dashed-id"
  />,
  <SelectInput
    key="status"
    choices={statusChoices}
    source="status"
  />,
  <SelectInput
    key="deletedAt"
    label="Deleted Items"
    source="deletedAt"
    alwaysOn
    emptyText="Hidden"
    emptyValue="hidden"
    choices={[
      // { id: "hidden", name: "Hidden" },
      { id: 'visible', name: 'Visible' },
      { id: 'only', name: 'Only' },
    ]}
    format={value => {
      if (!value) {
        return 'hidden';
      }

      return value;
    }}
  />,
  <SelectInput
    key="isHiddenTestAccount"
    label="Test Accounts"
    source="isHiddenTestAccount"
    emptyText="Hidden"
    emptyValue="hidden"
    alwaysOn
    choices={[
      // { id: "hidden", name: "Hidden" },
      { id: 'visible', name: 'Visible' },
      { id: 'only', name: 'Only' },
    ]}
    format={value => {
      if (!value) {
        return 'hidden';
      }

      return value;
    }}
  />,
];

export const TherapistHomeworkList = () => (
  <List
    perPage={25}
    storeKey={false}
    actions={<DefaultListActions exporter={documentsCsvExporter} />}
    filters={filters}
    sort={{ field: 'createdAt', order: 'DESC' }}
    pagination={<DefaultPagination />}
    queryOptions={{
      meta: {
        facet: false,
      },
    }}
  >
    <DatagridConfigurable
      bulkActionButtons={false}
      expand={TherapistHomeworkCommandPanel}
      omit={renderOmitList(columns)}
    >
      {renderGridColumns(columns)}
    </DatagridConfigurable>
  </List>
);

const documentsCsvExporter = genericCSVExporter(
  'therapistHomework',
  renderExportColumns(columns),
);
